import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-gray-50"
}

import { computed, ref } from 'vue'
import { debounce } from 'lodash-es'
import type { CustomField } from '@zendesk/zqa-services/filters'
import { Modes } from '@klausapp/ui-kit/components/UiDropdownV2/types'
import { UiDropdownV2 as UiDropdown, UiMenuSelectTrigger } from '@klausapp/ui-kit'

import { session } from '@/composables/useSession'
import useHelpdeskCustomFieldValues from '@/modules/shared/filters/useHelpdeskCustomFieldValues'
import i18n from '@/i18n'

import type { DropdownSelectedValue } from './types'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomFieldValueDropdown',
  props: {
    modelValue: {},
    fieldExternalId: {},
    fieldName: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const searchQuery = ref('')
const handleSearch = debounce((search: string) => (searchQuery.value = search), 300)

const workspaceIds = computed(() => [session.workspace.id])

const { options, total, isLoading } = useHelpdeskCustomFieldValues(
  workspaceIds,
  computed(() => {
    return {
      customFieldId: props.fieldExternalId,
      search: searchQuery.value,
      limit: undefined,
      includeValues: props.modelValue.map((v) => v.value),
    }
  }),
)

const normalizedOptions = computed(() => {
  if (!options.value) return []
  const normalized = options.value.map((option) => ({
    label: option.label,
    value: option.value,
    name: option.value,
    isCustom: true,
    fieldId: props.fieldExternalId,
  }))

  // Make sure we always show selected values even if they are not included in the fetched options
  // This happens when users have more custom values than set limit of 50 and they search and select a value that is not in the first 50
  const selectedValues = props.modelValue.filter((mv) => normalized.every((no) => no.value !== mv.value))

  return [...selectedValues, ...normalized]
})

const getFieldLabel = (values) => {
  if (!values.length) return null
  if (values.length === 1) return values[0].label

  return i18n.t('universal.items_selected', values.length)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(UiDropdown), {
      "model-value": _ctx.modelValue,
      options: normalizedOptions.value,
      mode: _unref(Modes).Multiple,
      "is-loading": _unref(isLoading),
      "search-placeholder": _ctx.$t('universal.search'),
      "loading-text": _ctx.$t('pickers.loading_results'),
      "no-results-text": _ctx.$t('pickers.helpdesk_custom_field_values.no_results'),
      total: _unref(total),
      "has-search": "",
      "filter-results": "",
      "reorder-after-select": "",
      size: "lg",
      "is-object": true,
      "full-width": "",
      label: "label",
      "prop-to-check": "value",
      "append-to-document": "",
      onSearchChange: _unref(handleSearch),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
    }, {
      "trigger-multiple-selected": _withCtx(({ count }) => [
        _createTextVNode(_toDisplayString(_ctx.$t('universal.items_selected', Number(count))), 1 /* TEXT */)
      ]),
      trigger: _withCtx(({ active }) => [
        _createVNode(_unref(UiMenuSelectTrigger), {
          small: "",
          active: active
        }, {
          default: _withCtx(() => [
            (getFieldLabel(_ctx.modelValue))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(getFieldLabel(_ctx.modelValue)), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('filter.multiple_value_placeholder')), 1 /* TEXT */))
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active"])
      ]),
      "more-count": _withCtx(({ count }) => [
        _createTextVNode(_toDisplayString(_ctx.$t('universal.n_more_simple', { n: _ctx.$n(count) }, count)), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "options", "mode", "is-loading", "search-placeholder", "loading-text", "no-results-text", "total", "onSearchChange"])
  ]))
}
}

})